import { useState, useRef, useCallback } from "react";
import api from "../lib/api";

function log(...args) {
  if (process.env.NODE_ENV === "development") console.error(...args);
}

export function usePassengerData() {
  const [rides, setRides] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [trackingBookingId, setTrackingBookingId] = useState(null);
  const [driverLocation, setDriverLocation] = useState(null);
  const trackingIntervalRef = useRef(null);

  const fetchRides = useCallback(async (dep, dest, date, minP, maxP, minS) => {
    try {
      const params = new URLSearchParams();
      if (dep) params.append("departure", dep);
      if (dest) params.append("destination", dest);
      if (date) params.append("date", date);
      if (minP) params.append("min_price", minP);
      if (maxP) params.append("max_price", maxP);
      if (minS) params.append("min_seats", minS);
      params.append("hide_expired", "true");
      const { data } = await api.get(`/rides?${params.toString()}`);
      setRides(data);
    } catch (err) { log("Failed to fetch rides:", err.message); }
  }, []);

  const fetchVehicles = useCallback(async () => {
    try { const { data } = await api.get("/vehicles"); setVehicles(data); } catch (err) { log("Failed to fetch vehicles:", err.message); }
  }, []);

  const fetchBookings = useCallback(async () => {
    try { const { data } = await api.get("/bookings"); setBookings(data); } catch (err) { log("Failed to fetch bookings:", err.message); }
  }, []);

  const startLiveTracking = useCallback((bookingId) => {
    setTrackingBookingId(bookingId);
    if (trackingIntervalRef.current) clearInterval(trackingIntervalRef.current);
    const fetchLoc = async () => {
      try {
        const { data } = await api.get(`/location/booking/${bookingId}`);
        if (data.lat && data.lng) setDriverLocation(data);
      } catch (err) { log("Failed to poll location:", err.message); }
    };
    fetchLoc();
    trackingIntervalRef.current = setInterval(fetchLoc, 5000);
  }, []);

  const stopLiveTracking = useCallback(() => {
    if (trackingIntervalRef.current) { clearInterval(trackingIntervalRef.current); trackingIntervalRef.current = null; }
    setTrackingBookingId(null);
    setDriverLocation(null);
  }, []);

  const cleanup = useCallback(() => {
    if (trackingIntervalRef.current) clearInterval(trackingIntervalRef.current);
  }, []);

  return {
    rides, vehicles, bookings, loading, setLoading,
    fetchRides, fetchVehicles, fetchBookings,
    trackingBookingId, driverLocation,
    startLiveTracking, stopLiveTracking, cleanup,
  };
}
